// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconArrowLeft = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.478 3.485a.75.75 0 01-.03 1.06L5.886 10.75H21a.75.75 0 010 1.5H5.885l6.564 6.205a.75.75 0 11-1.03 1.09l-7.934-7.5a.75.75 0 010-1.09l7.933-7.5a.75.75 0 011.06.03z"
      fill="currentColor"
    />
  );
export default SvgIconArrowLeft;
